import React from 'react';
import classnames from 'classnames';
import { Modal as Modal1C } from '@1c/ui';
import Text from 'src/components/Text';
import styles from './styles.module.scss';

type Props = {
  isOpen: boolean;
  onClose: () => void;
  title?: string;
  content?: React.ReactNode;
  footer?: React.ReactNode;
};

const Modal: React.FC<Props> = props => {
  const { isOpen, onClose, title, content, footer } = props;
  const contentClassNames = classnames('modal-content', styles['modal']);
  const bodyClassNames = classnames('modal-body', styles['body']);

  return (
    <Modal1C isOpen={isOpen} onRequestClose={onClose} className="modal-dialog" overlayClassName={styles['overlay']}>
      <div className={contentClassNames}>
        {title && <Text type="h2" className={styles['title']}>{title}</Text>}
        <div className={bodyClassNames}>{content}</div>
        {footer && <div className={styles['footer']}>{footer}</div>}
      </div>
    </Modal1C>
  );
};

export default Modal;
